export default {"src":"/_next/static/media/car_40.59a6c188.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};